import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcComponent } from '../fc';
import { registerLocaleData } from '@angular/common';
import zh from '@angular/common/locales/zh';
import { FcinputComponent } from '../fcinput';
registerLocaleData(zh);
/**
 * fc-calendaræ¥å
 * 
 * æç§æ¥åå½¢å¼å±ç¤ºæ°æ®çå®¹å¨ã
 * 
 * å½æ°æ®æ¯æ¥æææç§æ¥æååæ¶ï¼ä¾å¦æ¥ç¨ãè¯¾è¡¨ãä»·æ ¼æ¥åç­ï¼ååç­ãç®	åæ¯æå¹´/æåæ¢ã
 * 
 */
@Component({
    selector: 'fc-calendar',
    /**
     * @ignore
     */
    template: `
      <nz-calendar [nzFullscreen]="_fullScreen"  [(nzMode)]="fcMode">
       <ul *nzDateCell="let date" class="events">
         <ng-container [ngSwitch]="date.getDate()">
           <ng-container *ngSwitchCase="8">
             <li *ngFor="let item of listDataMap.eight">
               <nz-badge [nzStatus]="item.type" [nzText]="item.content"></nz-badge>
             </li>
           </ng-container>
           <ng-container *ngSwitchCase="10">
             <li *ngFor="let item of listDataMap.ten">
               <nz-badge [nzStatus]="item.type" [nzText]="item.content"></nz-badge>
             </li>
           </ng-container>
           <ng-container *ngSwitchCase="11">
             <li *ngFor="let item of listDataMap.eleven">
               <nz-badge [nzStatus]="item.type" [nzText]="item.content"></nz-badge>
             </li>
           </ng-container>
         </ng-container>
       </ul>
     </nz-calendar>
    `,
    styles: [`
    .events {
        list-style: none;
        margin: 0;
        padding: 0;
      }
  
      .events .ant-badge-status {
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
        text-overflow: ellipsis;
        font-size: 12px;
      }
  
      .notes-month {
        text-align: center;
        font-size: 28px;
      }
  
      .notes-month section {
        font-size: 28px;
      }
    `]
})
export class FccalendarComponent extends FcinputComponent {
     /** <nz-calendar [(ngModel)]="date" [(nzMode)]="mode"></nz-calendar>*/
    date = new Date(2012, 11, 21);
    mode = 'month';
     /** å±ç¤ºæ¥æå¼*/
    @Input()
    fcValue: string; /**é»è®¤å½åæ¥æ*/
     /** æ¯å¦å¨å±*/
    @Input()
    fcFullscreen: string;
    _fullScreen:boolean;
     /** æ¨¡å¼*/
    @Input()
    fcMode: string;
     /** å¤©æ¨¡å¼èªå®ä¹æ¾ç¤ºæ¨¡æ¿*/
    @Input()
    fcDateCell: string;
     /** ææ¨¡å¼èªå®ä¹æ¾ç¤ºæ¨¡æ¿*/
    @Input()
    fcMonthCell: string;
     /**æ¾ç¤ºæå­*/
    @Input()
    fcText: string;
     /**æ­»æ°æ®*/
    @Input()
    listDataMap:any={};
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-calendar');
    }
    
    ngOnChanges(param): void {
        super.ngOnChanges(param);
        if (this.fcValue === undefined) {
            this.fcValue = '';
        }
        if (this.fcFullscreen === undefined) {
            this._fullScreen = true;
        }
        if (this.fcMode === undefined) {
            this.fcMode = "month";
        }
    }
    _afterParentInit(){
      if(this.fcFullscreen == 'N'){
        this._fullScreen = false;
      }else{
        this._fullScreen = true;
      }
    }  
}
